import React, { useMemo } from 'react';

const Bubbles = ({ count = 8, className = '' }) => {
  const bubbles = useMemo(() => {
    return Array.from({ length: count }, (_, i) => ({
      id: i,
      size: Math.random() * 12 + 3,
      x: Math.random() * 100,
      y: Math.random() * 100,
      duration: Math.random() * 10 + 8,
      delay: Math.random() * 5,
      opacity: Math.random() * 0.15 + 0.03,
      shape: Math.random() > 0.7 ? 'square' : 'circle',
    }));
  }, [count]);

  return (
    <div className={`absolute inset-0 overflow-hidden pointer-events-none ${className}`} aria-hidden="true">
      {bubbles.map((b) => (
        <div
          key={b.id}
          className={`absolute bg-accent/20 ${
            b.shape === 'square' ? 'rounded-sm rotate-45' : 'rounded-full'
          }`}
          style={{
            width: `${b.size}px`,
            height: `${b.size}px`,
            left: `${b.x}%`,
            top: `${b.y}%`,
            opacity: b.opacity,
            animation: `bubbleFloat ${b.duration}s ease-in-out ${b.delay}s infinite alternate`,
          }}
        />
      ))}

      {/* Subtle gradient orbs for depth */}
      <div
        className="absolute w-64 h-64 rounded-full pointer-events-none"
        style={{
          background: 'radial-gradient(circle, rgba(201, 169, 110, 0.04) 0%, transparent 70%)',
          top: '10%',
          left: '5%',
          animation: 'bubbleFloat 15s ease-in-out 2s infinite alternate',
        }}
      />
      <div
        className="absolute w-48 h-48 rounded-full pointer-events-none"
        style={{
          background: 'radial-gradient(circle, rgba(201, 169, 110, 0.03) 0%, transparent 70%)',
          bottom: '15%',
          right: '10%',
          animation: 'bubbleFloat 12s ease-in-out 4s infinite alternate',
        }}
      />
    </div>
  );
};

export default Bubbles;
